import {Directive, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {isFileSizeWithinLimit} from "@wms/core";
import {get, forEach} from "lodash-es";

const MAX_FILE_SIZE: number = 50;

@Directive({
  selector: '[wmsResourceDropTarget]',
  standalone: true
})
export class WMSResourceDropTargetDirective {
  @Input() wmsResourceDropTarget!: any;
  @Output() dropView!: EventEmitter<boolean>;
  @Output() uploadDroppedFiles!: EventEmitter<FileList>;
  droppedFileList: FileList | undefined;

  constructor(private el: ElementRef) {
    this.dropView = new EventEmitter<boolean>();
    this.uploadDroppedFiles = new EventEmitter<FileList>();
  }

  ngOnInit(): void {
    this.el.nativeElement.addEventListener("drop", ($event: DragEvent): void => {
      $event.stopPropagation();
      $event.preventDefault();
      this.droppedFileList = get($event.dataTransfer, "files");
      forEach(this.droppedFileList, (droppedFile: File): void => {
        if (!isFileSizeWithinLimit(droppedFile, MAX_FILE_SIZE)) {
          this.dropView.emit(false);
          return;
        }
      });
      this.uploadDroppedFiles.emit(this.droppedFileList);
    });
    this.el.nativeElement.addEventListener("dragleave", ($event: DragEvent): void => {
      $event.stopPropagation();
      $event.preventDefault();
      if (($event.target as HTMLDivElement).classList.contains("dropbox")) {
        this.dropView.emit(false);
      }
    });
    this.el.nativeElement.addEventListener("dragenter", ($event: DragEvent): void => {
      $event.stopPropagation();
      $event.preventDefault();
      this.dropView.emit(true);
    });
    this.el.nativeElement.addEventListener("dragover", ($event: DragEvent): void => {
      $event.stopPropagation();
      $event.preventDefault();
      this.droppedFileList = undefined;
    });
  }
}
